import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';
import SignUp from '../SignUp/SignUp';
import { completedRoutes } from '../../common/constants';
import { lazyWithDelay } from '../../common/lazyWithDelay';
import CustomBackdrop from '../common/CustomBackdrop';

const Rules = lazyWithDelay(import('../common/Rules/Rules'));

export default function AuthPage() {

  return (
    <React.Fragment>
      <Container component="main" maxWidth="xs">
        <Grid container spacing={0}
              justify="space-between"
              direction="column"
        >
          <Grid item xs={12}>
            <SignUp />
          </Grid>
        </Grid>
      </Container>
      <Switch>
        <Route path={completedRoutes.signRules}>
          <React.Suspense fallback={<CustomBackdrop open />}>
            <Rules to={completedRoutes.signRules} />
          </React.Suspense>
        </Route>
      </Switch>
    </React.Fragment>
  )
}
